import React from 'react';

/**
 * React's forwardRef erases a render function's type parameter, so a list
 * typed by its items (`items: Iterable<T>`, `children: (item: T) => ...`)
 * would lose T at the ref boundary. The same forwardRef, typed to keep it:
 * the React Aria pattern. For the components typed by their items only.
 */
export const forwardRef = React.forwardRef as <T, P = object>(
  render: (props: P, ref: React.ForwardedRef<T>) => React.ReactElement | null,
) => (props: P & React.RefAttributes<T>) => React.ReactElement | null;
